<template>
    <div>
        <div class="l-content__block">
            <div class="c-block__headings">
                <h2 class="">{{ model_list_name }}モデル一覧</h2>
            </div>
            <ul class="filter-by-name">
                <li v-for="(val, index) in str" :key="index">
                    <a :href="route(route_list, 'site.talent.index', getParams(index))" class="" :id=head+val.id>{{ index }}</a>
                </li>
            </ul>

            <div class="models">
                <template v-if="talentLists != null">
                    <span v-for="(talent, index, talent_index) in talentLists" :key="index">
                        <div class="anchor" :id="makeAnchorLink(talent_index)"></div>
                        <h3><span>{{ index }}</span></h3>
                        <ul class="filter-by-name">
                            <li v-for="(vowel, vowel_index) in vowels">
                                <a :href="'#' + makeAnchorLink(vowel_index)" :class="onActiveIfEqVowel(talent_index, vowel_index)">{{ vowel }}</a>
                            </li>
                        </ul>
                        <ul class="models__list">
                            <li class="c-slider-model__item" v-for="(talent_val, i) in talent" :key="i">
                                <a :href="route(route_list, 'site.talent.detail', {model_id:talent_val['id'], model_name:talent_val['name']})">
                                    <div class="c-slider-model__img">
                                        <img :src="talent_val['thumbnail_file_path']" alt="">
                                    </div>
                                    <p class="c-slider-model__name" v-html="talent_val['name']"></p>
                                </a>
                            </li>
                        </ul>
                    </span>
                </template>
            </div>

            <ul class="filter-by-name">
                <li v-for="(val, index) in str" :key="index">
                    <a :href="route(route_list, 'site.talent.index', getParams(index))" class="" :id=foot+val.id>{{ index }}</a>
                </li>
            </ul>

        </div>
        <!-- おすすめモデル -->
        <div class="recommend-talents l-content__block">
            <recommendTalents
                :route_list='route_list'
                :recommend_categories='recommend_categories'
                recommend_from=''
                :recommender_string='recommender_string'
                number_of_result='20'
                limit='5'
            ></recommendTalents>
        </div>
    </div>
</template>

<script>
import routeMixin from '../../mixins/route.js';
import recommendTalents from './RecommendTalents.vue';
export default {
    components: {
        recommendTalents,
    },
    props: [
        'talentLists',
        'alphabetList',
        'params',
        'route_list',
        'image_path',
        'filter',
        'model_list_name',
    ],
    mixins: [routeMixin],
    data () {
        return {
            str: this.alphabetList,
            head: "head_",
            foot: "foot_",
            // 母音リスト
            vowels: this.setVowels(),
            recommend_categories: ['talent'],
            recommender_string: 'mostviewed',
        }
    },
    mounted(){
        this.$nextTick(() => {
            document.getElementById(this.head+this.str[this.params].id).classList.add('active');
            document.getElementById(this.foot+this.str[this.params].id).classList.add('active');
        });
    },
    methods: {
        /*
        * 各ひらがな行を生成する。talentListsの添字から取得しvowelsに代入
        * タレントリストに存在しない頭文字は生成されない
        * @return array 各ひらがな行
        */
        setVowels: function() {
            if (!this.talentLists) return [];
            return Object.keys(this.talentLists);
        },
        /*
        * ジャンプリンク用のアンカー名称作成
        * @param int index 各index
        * @return string "name_0*" *には index+1 の値が入る
        */
        makeAnchorLink: function(index) {
            return 'name_0' + String(index + 1);
        },
        /*
        * classにactiveを付与する
        * @param int talent_index
        * @param int vowel_index
        * @return string true: 'active' / false: null
        */
        onActiveIfEqVowel: function(talent_index, vowel_index) {
            return (talent_index === vowel_index)? 'active' : null;
        },
        /**
         * route()に渡すパラメータを返す
         * @param index
         * @returns {{model_name_index}|{filter, model_name_index}}
         */
        getParams(index) {
            if (this.filter) {
                return {model_name_index:index, filter:this.filter}
            }
            return {model_name_index:index}
        }
    },
}
</script>

<style lang="scss" scoped>
.l-content{
    @media screen and (max-width: 767px) {
    margin-top: 35px;
    }

    &.is_plus_contents{
        .c-block__headings {
            h2::before {
            -webkit-transform: translateX(-50%);
            background-color: #e47931;
            bottom: 0;
            content: '';
            display: block;
            font-size: 20px;
            height: 6px;
            left: 50%;
            position: absolute;
            transform: translateX(-50%);
            width: calc(100% - 0.7em);
            }
        }

        .filter-by-name{
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            margin: 0 0 55px;
            @media screen and (max-width: 767px) {
                margin: 0 auto 20px;
                max-width: 240px;
            }
            li{
                width: 40px;
                margin: 0 6px;
                @media screen and (max-width: 767px) {
                    width: 36px;
                    margin: 0 6px 6px;
                }
                a{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    font-size: 14px;
                    font-weight: bold;
                    border: 1px solid #dde9ec;
                    @media screen and (max-width: 767px) {
                        width: 36px;
                        height: 36px;
                        font-size: 12px;
                    }
                    &:hover, &.active{
                        background: #ff873c;
                        border-color: #ff873c;
                        color: #fff;
                    }
                    &.active {
                        pointer-events: none;
                    }
                }
            }
        }

        .models{
            margin: 0 0 20px;
            @media screen and (max-width: 767px) {
                margin: 0 0 10px;
            }
            h3{
                color: #e47931;
                margin: 0 0 20px;
                span{
                    position: relative;
                    padding: 0 20px;
                    &::before, &::after{
                        content: "";
                        width: 50px;
                        height: 1px;
                        background: #e47931;
                        position: absolute;
                        top: 50%;
                        margin: -1px 0 0;
                        @media screen and (max-width: 767px) {
                            width: 40px;
                        }
                    }
                    &::before{
                        right: 100%;
                    }
                    &::after{
                        left: 100%;
                    }
                }
            }
            .models__list{
                display: flex;
                flex-wrap: wrap;
                li{
                    width: 20%;
                    margin: 0 0 15px;
                    @media screen and (max-width: 767px) {
                        width: 33.33%;
                        margin: 0 0 20px;
                    }
                    .c-slider-model__img{
                        border-color: #e47931;
                        @media screen and (max-width: 767px) {
                            margin-bottom: 10px;
                            height: 25.34vw;
                        }
                    }

                    .c-slider-model__name{
                        min-height: 40px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        line-height: 18px;
                    }

                    a:hover .c-slider-model__name {
                        color: #e47931;
                    }
                }
            }
        }
    }
}
.filter-by-name{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 0 0 55px;
    @media screen and (max-width: 767px) {
        margin: 0 auto 20px;
        max-width: 240px;
    }
    li{
        width: 40px;
        margin: 0 6px;
        @media screen and (max-width: 767px) {
            width: 36px;
            margin: 0 6px 6px;
        }
        a{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            font-size: 14px;
            font-weight: bold;
            border: 1px solid #dde9ec;
            @media screen and (max-width: 767px) {
                width: 36px;
                height: 36px;
                font-size: 12px;
            }
            &:hover, &.active{
                background: #00b3d6;
                border-color: #00b3d6;
                color: #fff;
            }
            &.active {
                pointer-events: none;
            }
        }
    }
}
.anchor {
    @media (min-width:768px){
        padding-top: 85px;
        margin-top: -85px;
    }
    @media (max-width:767px){
        padding-top: 75px;
        margin-top: -75px;
    }
}
.models{
    margin: 0 0 20px;
    @media screen and (max-width: 767px) {
        margin: 0 0 10px;
    }
    h3{
        color: #00b3d6;
        margin: 0 0 20px;
        span{
            position: relative;
            padding: 0 20px;
            &::before, &::after{
                content: "";
                width: 50px;
                height: 1px;
                background: #00b3d6;
                position: absolute;
                top: 50%;
                margin: -1px 0 0;
                @media screen and (max-width: 767px) {
                    width: 40px;
                }
            }
            &::before{
                right: 100%;
            }
            &::after{
                left: 100%;
            }
        }
    }
    .models__list{
        display: flex;
        flex-wrap: wrap;
        li{
            width: 20%;
            margin: 0 0 15px;
            @media screen and (max-width: 767px) {
                width: 33.33%;
                margin: 0 0 20px;
            }
            .c-slider-model__img{
                @media screen and (max-width: 767px) {
                    margin-bottom: 10px;
                    height: 25.34vw;
                }
            }

            .c-slider-model__name{
                min-height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                line-height: 18px;
            }
        }
    }
}
</style>
